export class ErrorModel {
    constructor(source) {
        Object.keys(source).forEach(x => {
            this[x] = source[x];
        }, this);
    }
}
//# sourceMappingURL=ErrorModel.js.map